<script lang="ts" setup>
import type { IArticleCategory } from '~/api/article';

const props = defineProps({
  data: {
    type: Array as PropType<IArticleCategory[]>,
    default: () => { }
  },
  currentCategoryId: {
    type: Number as PropType<any>,
    default: null
  }
})

const route = useRoute()
const { mainId, subId } = route.params

const currentIndex = ref(0);

currentIndex.value = props.data.findIndex((item) => item.id == mainId);

const handleClick = (index: number) => {
  currentIndex.value = index;
};
</script>

<template>
  <section class="side">
    <div class="side__title">永續生活</div>
    <ul class="side__lists">
      <li v-for="(category, index) in data" :key="category.id">
        <div class="side__lists__title" :class="{ active: currentIndex === index }" @click="handleClick(index)">
          {{ category.subject }}
          <svg-icon name="icon-arrow-down" />
        </div>
        <transition>
          <div class="side__lists__sub" v-show="currentIndex === index">
            <nuxt-link :to="`/sustainability/${category?.seo?.meta_slug || category.id}`"
              :class="{ active: category.id == currentCategoryId }">所有文章</nuxt-link>
            <nuxt-link
              :to="`/sustainability/${category?.seo?.meta_slug || category.id}/${subcategory?.seo?.meta_slug || subcategory.id}`"
              v-for="subcategory in category.children" :key="subcategory.id"
              :class="{ active: subcategory.id == currentCategoryId }">
              {{ subcategory.subject }}
            </nuxt-link>
          </div>
        </transition>
      </li>
    </ul>
  </section>
</template>

<style lang="scss" scoped>
.side {
  text-align: right;

  @include max-media(960) {
    text-align: center;
  }

  &__title {
    margin-bottom: toRem(24);
    color: $blue3;
    font-weight: 500;
    line-height: 1.3;

    @include min-media(961) {
      font-size: 3.3vw;
    }

    @include max-media(960) {
      font-size: toRem(32);
    }
  }

  &__lists {
    @include max-media(960) {
      display: flex;
      justify-content: space-between;
      width: 100%;
      position: relative;
      padding-bottom: toRem(45);
      margin-bottom: toRem(15);
    }

    li {
      &:not(:last-child) {
        @include min-media(961) {
          margin-bottom: toRem(24);
        }
      }
    }

    &__title {
      position: relative;
      margin-bottom: toRem(12);
      padding-right: toRem(24);
      font-size: toRem(20);
      font-weight: 500;
      line-height: 1.4;
      color: $blue2;
      cursor: pointer;

      @include max-media(960) {
        padding-left: toRem(5);
        padding-right: toRem(5);
        padding-bottom: toRem(18);
      }

      @include max-media(480) {
        font-size: toRem(16);
      }

      @include max-media(380) {
        font-size: toRem(14);
      }

      svg {
        position: absolute;
        right: 0;
        top: toRem(2);
        width: toRem(24);
        height: toRem(24);
        transition: all 0.5s;

        @include max-media(960) {
          right: auto;
          top: auto;
          left: 50%;
          bottom: 0;
          width: toRem(20);
          height: toRem(20);
          margin-left: toRem(-10);
          transform: scaleY(-1);
          opacity: 0;
        }
      }

      &.active {
        svg {
          transform: scaleY(-1);

          @include max-media(960) {
            transform: scaleY(1);
            opacity: 1;
          }
        }
      }
    }

    &__sub {
      @include max-media(960) {
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        flex-wrap: wrap;
        width: calc(100vw - toRem(48));
        padding: toRem(12);
        border-radius: toRem(4);
        background-color: $color-white-1;
      }

      a {
        display: block;
        font-size: toRem(16);
        color: $blue3;

        @include max-media(960) {
          font-size: toRem(14);
        }

        @include max-media(380) {
          font-size: toRem(12);
        }

        &.active {
          color: $blue2;
        }

        &:not(:last-child) {
          @include min-media(961) {
            margin-bottom: toRem(12);
          }

          @include max-media(960) {
            margin-right: toRem(8);
          }
        }
      }
    }
  }
}
</style>
